import React from "react";
import { trim } from "../utils";
import { searchType } from "../../common/types/search/search";

interface SearchSelectedProps {
	label: string;
	current?: searchType;
}

export function SearchSelected({ current, label }: SearchSelectedProps) {
	const searchName = current ? trim(current.name, 15) : "Unsaved";

	return (
		<div className="flex info--text">
			<p>{label}</p>
			<span>{searchName}</span>
		</div>
	);
}
